import { useCallback } from 'react';
import { useAsync } from './useAsync';
import { listCreatives, getCreative } from '@/services/creatives';
import type { ListCreativesParams } from '@/services/creatives';
import type { Creative } from '@/types/api';

export function useCreatives(params: ListCreativesParams = {}) {
  const { limit = 50, campaign_id } = params;
  const fn = useCallback(
    () => listCreatives({ limit, campaign_id }).then((page) => page.items),
    [limit, campaign_id],
  );
  return useAsync<Creative[]>(fn);
}

export function useCreative(id: number | null) {
  const fn = useCallback(
    () => (id != null ? getCreative(id) : Promise.reject(new Error('No ID'))),
    [id],
  );
  return useAsync<Creative>(id != null ? fn : null);
}
